import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { ownerNavigation } from '../../lib/ownerNavigation';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';

export const OwnerNavigation = ({ collapsed = false, onNavigate }) => {
  const { pathname } = useLocation();
  const [groups, setGroups] = useState({});
  useEffect(() => {
    const active = ownerNavigation.find(group => group.items.some(item => item[1] === pathname));
    if (active?.label) setGroups(current => ({ ...current, [active.label]: true }));
  }, [pathname]);
  return <TooltipProvider delayDuration={100}><nav aria-label="Owner navigation" className="owner-navigation" data-testid="owner-navigation">
    {ownerNavigation.map(group => <div key={group.label || 'overview'} className="owner-nav-group">
      {group.label && !collapsed && <button data-testid={`owner-nav-group-${group.label.toLowerCase()}`} aria-expanded={groups[group.label] !== false} className="owner-nav-group-toggle" onClick={() => setGroups(current => ({ ...current, [group.label]: current[group.label] === false }))}>
        <span>{group.label}</span><ChevronDown aria-hidden="true" size={14} className={groups[group.label] === false ? '-rotate-90' : ''} />
      </button>}
      {(collapsed || !group.label || groups[group.label] !== false) && group.items.map(([label, to, Icon, id]) => {
        const link = <NavLink end to={to} data-testid={`owner-nav-${id}`} aria-label={label} onClick={onNavigate} className={({ isActive }) => `owner-nav-link ${isActive ? 'active' : ''}`}>
          <Icon size={20} aria-hidden="true" className="shrink-0" /><span className={collapsed ? 'sr-only' : ''}>{label}</span>
        </NavLink>;
        return collapsed ? <Tooltip key={to}><TooltipTrigger asChild>{link}</TooltipTrigger><TooltipContent side="right" data-testid={`owner-nav-tooltip-${id}`}>{label}</TooltipContent></Tooltip> : <React.Fragment key={to}>{link}</React.Fragment>;
      })}
    </div>)}
  </nav></TooltipProvider>;
};